import { gql } from '@apollo/client';

export const CHECK_VAT = gql`
  query CHECK_VAT($iso2: String!, $vatNumber: String!) {
    checkVat(iso2: $iso2, vatNumber: $vatNumber)
  }
`;
